import style from './LoadingSpinner.module.sass'

export function LoadingSpinner() {
	return (
		<span className={style.container}>
			<span className={style.spinner} />
		</span>
	)
}
